import { resolveApiUrl } from "~/utils/url/urlResolver";
import { waitForSessionExpiryLogout } from "~/features/auth/api/doLogout";

export interface ResponseData {
  globalErrors: string[];
  validationResults: FieldValidationResults;
}

export type FieldValidationResults = {
  [fieldName: string]: string[] | undefined;
};

interface Props {
  login: string;
  password: string;
  timezone: string;
}

const apiUrl = resolveApiUrl("/j_spring_security_check");

export async function sendLoginRequest(data: Props): Promise<{ error?: string; redirectUrl?: string }> {
  const params = new URLSearchParams();
  params.set("j_username", data.login);
  params.set("j_password", data.password);

  await waitForSessionExpiryLogout();
  return fetch(apiUrl, {
    body: params.toString(),
    cache: "no-cache",
    credentials: "same-origin",
    method: "POST",
    mode: "cors",
    headers: {
      dataType: "json",
      "content-type": "application/x-www-form-urlencoded",
    },
    redirect: "follow",
  }).then((response) => {
    if (!response.ok) {
      if (response.headers.get("SchaefAnonymousTimeOut") === "true") {
        const params = new URLSearchParams(window.location.search);
        params.append("timeout", "true");
        return {
          redirectUrl: window.location.origin + window.location.pathname + "?" + params.toString(),
        };
      }
      if (response.status === 401 || response.status === 409) {
        return response.text().then((text) => ({ error: text }));
      }
      throw new Error("Error");
    }
    return {
      redirectUrl: response.headers.get("schaRedirectUrl") ?? undefined,
    };
  });
}
